// extracted by mini-css-extract-plugin
export default {"content":"style_content__zdMx8","itemName":"style_itemName__PoRPF"};